import { Spinner } from "@jobber/components/Spinner";
import { useUserContext } from "@/contexts";
import { redirectToJobberOAuth } from "@/helpers";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authenticateUser } from "@/services";
import { Button, showToast } from "@jobber/components";

const Auth = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const navigate = useNavigate();
  const { setUser } = useUserContext();

  useEffect(() => {
    if (code) {
      (async () => {
        try {
          const { data: user } = await authenticateUser(code);
          setUser(user);
          navigate("/home", { replace: true });
        } catch (e) {
          console.log(e);
          showToast({
            message: "Authentication failed",
            variation: "error",
          });
          navigate("/auth", { replace: true });
          return;
        }
      })();
    }
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      {code ? (
        <>
        <Spinner />
        <h1>Authentication in progress</h1>
        </>
      ): (
        <>
        <h1>Please login to continue</h1>
        <Button
          label="login"
          onClick={() => redirectToJobberOAuth()}
        />
        </>
      )}
    </div>
  );
};

export default Auth;
